jQuery(document).ready(function ($) {
  const $mobileMenuToggle = $(".mobile-menu-toggle");
  const $mobileNavigation = $(".mobile-navigation");

  // Toggle mobile menu
  $mobileMenuToggle.on("click", function () {
    $mobileNavigation.toggleClass("active");
    $mobileMenuToggle.toggleClass("active");
  });

  // Clique sur la flèche pour afficher ou masquer le sous-menu
  $(".mobile-nav-menu-principal .menu-item-has-children > a").on(
    "click",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Trouve le parent li de l'élément cliqué
      const parentLi = $(this).closest("li");

      // Affiche ou masque le sous-menu du parent li
      parentLi.children(".sub-menu").toggleClass("active");

      // Ajoute ou supprime la classe 'open' pour indiquer l'état du sous-menu
      parentLi.toggleClass("open");
    },
  );

  // Reset menu mobile au passage en desktop
  $(window).on("resize", function () {
    if ($(window).width() >= 992) {
      $mobileNavigation.removeClass("active");
      $mobileMenuToggle.removeClass("active");
    }
  });

  // Toggle formulaire de recherche
  $(".search-toggle").on("click", function (e) {
    e.stopPropagation();

    const $toggle = $(this);
    const $wrapper = $toggle.siblings(".search-form-wrapper");

    const isActive = $wrapper.toggleClass("active").hasClass("active");

    $toggle.toggleClass("active");
    $toggle.attr("aria-expanded", isActive);

    if (isActive) {
      $wrapper.find('input[type="search"]').trigger("focus");
    }
  });

  // Fermer la recherche si clic à l'extérieur
  $(document).on("click", function (e) {
    $(".header__search").each(function () {
      const $container = $(this);
      const $wrapper = $container.find(".search-form-wrapper");

      const clickedInside =
        $container.has(e.target).length > 0 || $container.is(e.target);

      if (!clickedInside) {
        $wrapper.removeClass("active");

        $container
          .find(".search-toggle")
          .removeClass("active")
          .attr("aria-expanded", false);
      }
    });
  });

  // Fermer avec Échap
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      $(".search-form-wrapper").removeClass("active");

      $(".search-toggle").removeClass("active").attr("aria-expanded", false);
    }
  });
});
